/** @deprecated since v5.0. Please use mat-table instead */
export enum TerraHrefTypeEnum {
    email = 'mailto',
    phone = 'tel',
    url = 'url',
    function = 'function'
}
